import type { DeviceModelFeature } from '../../services/admin';

/** "Supported Features" section of the model editor: which application features this hardware
 * model can support at all. A radio's own per-feature setting only applies inside this set. */
export default function ModelFeaturesEditor({
  rows,
  onChange,
}: {
  rows: DeviceModelFeature[];
  onChange: (rows: DeviceModelFeature[]) => void;
}) {
  return (
    <div className="space-y-2 border-t border-gray-700 pt-4">
      <p className="text-sm font-semibold text-gray-300">Supported Features</p>
      <p className="text-xs text-gray-500">
        Application features this model can support. Unsupported features are hidden from every radio of this model and
        from its settings, whatever the radio's own setting says.
      </p>
      {rows.length === 0 ? (
        <p className="text-xs text-gray-500 italic">Save the model first to configure its features.</p>
      ) : (
        <div className="grid grid-cols-2 gap-2">
          {rows.map((row) => (
            <label key={row.code} className="flex items-center gap-2 text-sm text-gray-300" data-feature-row={row.code}>
              <input
                type="checkbox"
                checked={row.supported}
                onChange={(e) => onChange(rows.map((r) => (r.code === row.code ? { ...r, supported: e.target.checked } : r)))}
              />
              {row.name}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
